module.exports = __webpack_public_path__ + "static/img/app.1bb733a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/app.svg
// module id = oCuK
// module chunks = 1